const CEFR_ORDER = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'] as const

const CEFR_BAR_COLORS: Record<string, string> = {
  A1: 'bg-green-500',
  A2: 'bg-emerald-500',
  B1: 'bg-blue-500',
  B2: 'bg-violet-500',
  C1: 'bg-orange-500',
  C2: 'bg-red-500',
}

interface LevelBreakdownProps {
  vocabularyByLevel: Record<string, number>
}

export function LevelBreakdown({ vocabularyByLevel }: LevelBreakdownProps) {
  const maxCount = Math.max(...CEFR_ORDER.map((l) => vocabularyByLevel[l] ?? 0), 1)

  return (
    <div className="space-y-3">
      {CEFR_ORDER.map((level) => {
        const count = vocabularyByLevel[level] ?? 0
        const pct = (count / maxCount) * 100
        return (
          <div key={level} className="flex items-center gap-3">
            <span className="w-8 shrink-0 text-sm font-semibold text-muted-foreground">
              {level}
            </span>
            <div className="h-3 flex-1 overflow-hidden rounded-full bg-muted">
              <div
                className={`h-full rounded-full transition-all duration-500 ${CEFR_BAR_COLORS[level]}`}
                style={{ width: `${pct}%` }}
              />
            </div>
            <span className="w-16 shrink-0 text-right text-sm text-muted-foreground">
              {count} {count === 1 ? 'word' : 'words'}
            </span>
          </div>
        )
      })}
    </div>
  )
}
